import ButtonLinkSitioWeb from "./ButtonLinkSitioWeb";
import IconLealtad from "./IconLealtad";
import { Email } from "react-obfuscate-email";

const { __ } = wp.i18n;

export default function TableONGsItem({ ong }) {


  const isValidEmail = (email) => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/; // Simple regex for demonstration; consider more comprehensive validation
    return regex.test(email);
  }

  const createMailtoLink = (email) => {
    if (!isValidEmail(email)) {
      return '#';
    }
    return `mailto:${email}`;
  }

  return (
    <div key={ong.id} className="table-row">
      <div className="table-cell table-cell__lealtad">
        {ong.lealtad_web ? <IconLealtad /> : ''}
      </div>
      <div className="table-cell table-cell__nombre">
        {ong.title ? ong.title : '-'}
      </div>
      <div className="table-cell table-cell__codigo">
        {ong.identificador}
      </div>
      <div className="table-cell table-cell__email">

        {ong.email ? (
          <Email email={ong.email}>
            {ong.email}
          </Email>
        ) : '-'}
      </div>
      <div className="table-cell table-cell__website">
        {ong.website ? (
          <ButtonLinkSitioWeb link={ong.website} />
        ) : '-'}
      </div>
    </div>
  )
}